import { MotionStyle, Transition } from "framer-motion";

export const mergeAnimations = (...animations: MotionStyle[]) => {
  let finalAnimation = {};

  animations.forEach((animation) => {
    finalAnimation = { ...finalAnimation, ...animation };
  });
};

const VIEWPORT = { once: true, amount: 0.3 };

export const HIDDEN_OPACITY = { opacity: 0 };

export const HIDDEN_SCALE = { ...HIDDEN_OPACITY, scale: 0.7 };

export const NO_ROTATION = { translate: "rotate(0deg)" };

export const HIDDEN_COLLAPSED_X = { ...HIDDEN_OPACITY, width: 0 };

export const HIDDEN_DISPLACED_X = (displacement: number | string) => ({
  ...HIDDEN_OPACITY,
  x: displacement
});

export const TO_NORMAL_OPACITY = { opacity: 1 };

export const TO_NORMAL_SCALE = { scale: 1, ...TO_NORMAL_OPACITY };

export const TO_NORMAL_POSITION = { x: 0, y: 0, ...TO_NORMAL_OPACITY };

export const TO_CONTENT_WIDTH = { width: "fit-content", ...TO_NORMAL_OPACITY };

export const COMPLETE_ROTATION = { transform: "rotate(360deg)" };

export const SLIDE_IN_X = (
  displacement: number | string,
  transition?: Transition
) => ({
  transition: { duration: 1, type: "spring", ...transition },
  viewport: VIEWPORT,
  whileInView: TO_NORMAL_POSITION,
  initial: HIDDEN_DISPLACED_X(displacement)
});

export const POP_IN = (transition?: Transition) => ({
  transition: { duration: 1, type: "spring", ...transition },
  viewport: VIEWPORT,
  whileInView: TO_NORMAL_SCALE,
  initial: HIDDEN_SCALE
});

export const ROTATE = (when: string, transition?: Transition) => ({
  transition: { duration: 1, repeat: Infinity, type: "linear", ...transition },
  viewport: VIEWPORT,
  [when]: COMPLETE_ROTATION
  // initial: NO_ROTATION
});

export const EXPAND = (transition?: Transition) => ({
  transition: { duration: 1, type: "spring", ...transition },
  viewport: VIEWPORT,
  whileInView: TO_CONTENT_WIDTH,
  initial: HIDDEN_COLLAPSED_X
});

export const Z_3D = (level: number) => ({
  transform: `translate3d(0, 0, ${level * 50}px)`
});
